/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'expenseCategories/auto-loan-transportation': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M22.18 9.24L20.49 3.6a3 3 0 00-2.89-2.15H6.28A3 3 0 003.39 3.6L1.7 9.23A3 3 0 00-.12 12v6a1.52 1.52 0 001.51 1.51V21a1.5 1.5 0 001.51 1.55h1.5A1.5 1.5 0 005.91 21v-1.5H18v1.51a1.5 1.5 0 001.51 1.5H21a1.5 1.5 0 001.5-1.5v-1.47A1.51 1.51 0 0024 18v-6a3 3 0 00-1.82-2.76zM6.28 4.46H17.6L19 9H5l1.28-4.54zm-.37 11.31a1.51 1.51 0 111.51-1.51 1.52 1.52 0 01-1.51 1.51zm12.06 0a1.51 1.51 0 111.51-1.51A1.52 1.52 0 0118 15.77z"/>'
  }
})
